import { EligibleStaffResponse } from '@/core/models/planning.model'

/** Strip diacritics and lowercase so "Désiré" matches a "desire" query. */
export const normalizeText = (value: string) =>
  value
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()

/**
 * MUI Autocomplete `filterOptions` for the staff picker. Diacritic-insensitive,
 * case-insensitive substring search across the staff's full name, speciality,
 * establishment and email — fixes the prefix-only / first-name-only native Select search.
 */
export function filterStaffOptions(options: EligibleStaffResponse[], { inputValue }: { inputValue: string }) {
  const query = normalizeText(inputValue.trim())
  if (!query) return options
  return options.filter((staff) =>
    normalizeText(
      `${staff.userInfo.name} ${staff.userInfo.surname} ${staff.speciality ?? ''} ${staff.establishment?.name ?? ''} ${staff.email ?? ''}`
    ).includes(query)
  )
}
